import React from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

const checkHash = (hash, path) => hash.find(h => h === path);

const AdmissionMenu = ({ location, isAdmission }) => {
	const hash = location.hash.split('#');
	const staff = useSelector(state => state.user.profile);

	return (
		<div className="top-bar color-scheme-light">
			<ul>
				{!['inventory-audit', 'internal-control-audit'].includes(staff.role.slug) && (
					<>
						<li className={checkHash(hash, 'ward-round') ? 'active' : ''}>
							<Link to={`${location.pathname}#ward-round`} className="pointer">
								Notes
							</Link>
						</li>
						{isAdmission && (
							<li className={checkHash(hash, 'encounters') ? 'active' : ''}>
								<Link to={`${location.pathname}#encounters`} className="pointer">
									Encounters
								</Link>
							</li>
						)}
						<li className={checkHash(hash, 'clinical-tasks') ? 'active' : ''}>
							<Link to={`${location.pathname}#clinical-tasks`} className="pointer">
								Tasks
							</Link>
						</li>
						<li className={checkHash(hash, 'nurse-observations') ? 'active' : ''}>
							<Link to={`${location.pathname}#nurse-observations`} className="pointer">
								Observations
							</Link>
						</li>
						{isAdmission && (
							<li className={checkHash(hash, 'lab') ? 'active' : ''}>
								<Link to={`${location.pathname}#lab`} className="pointer">
									Lab
								</Link>
							</li>
						)}
						<li className={checkHash(hash, 'regimen') ? 'active' : ''}>
							<Link to={`${location.pathname}#regimen`} className="pointer">
								Regimen
							</Link>
						</li>
						<li className={checkHash(hash, 'fluid-chart') ? 'active' : ''}>
							<Link to={`${location.pathname}#fluid-chart`} className="pointer">
								Fluid Chart
							</Link>
						</li>
						<li className={checkHash(hash, 'feeding-chart') ? 'active' : ''}>
							<Link to={`${location.pathname}#feeding-chart`} className="pointer">
								Feeding Chart
							</Link>
						</li>
						<li className={checkHash(hash, 'vitals') ? 'active' : ''}>
							<Link to={`${location.pathname}#vitals#Blood Pressure`} className="pointer">
								Vitals
							</Link>
						</li>
						<li className={checkHash(hash, 'care-team') ? 'active' : ''}>
							<Link to={`${location.pathname}#care-team`} className="pointer">
								Care Team
							</Link>
						</li>
						{isAdmission && (
							<li className={checkHash(hash, 'consumables') ? 'active' : ''}>
								<Link to={`${location.pathname}#consumables`} className="pointer">
									Consumables
								</Link>
							</li>
						)}
						<li className={checkHash(hash, 'discharge-note') ? 'active' : ''}>
							<Link to={`${location.pathname}#discharge-note`} className="pointer">
								Discharge Note
							</Link>
						</li>
						<li className={checkHash(hash, 'seizure-chart') ? 'active' : ''}>
							<Link to={`${location.pathname}#seizure-chart`} className="pointer">
								Seizure Chart
							</Link>
						</li>
						<li className={checkHash(hash, 'ebt-chart') ? 'active' : ''}>
							<Link to={`${location.pathname}#ebt-chart`} className="pointer">
								EBT Chart
							</Link>
						</li>
					</>
				)}
				<li className={checkHash(hash, 'nursing-service') ? 'active' : ''}>
					<Link to={`${location.pathname}#nursing-service`} className="pointer">
						Nursing Service
					</Link>
				</li>
			</ul>
		</div>
	);
};

export default withRouter(AdmissionMenu);
